// 登录，退出
export const LOGIN = 'LOGIN'
export const WXLOGIN = 'WXLOGIN'
export const LOGOUT = 'LOGOUT'
